import {Environment, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import * as tracking from '../../../tracking';
import {trackAndCommitMutation} from '../../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {UpdateSavedReportInput, updateSavedReportMutation} from './__generated__/updateSavedReportMutation.graphql';
import {UploadableMap} from 'relay-runtime';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';

const mutation = graphql`
	mutation updateSavedReportMutation($input: UpdateSavedReportInput!) {
		updateSavedReport(input: $input) {
			savedReport {
				id
				updatedAt
				updatedBy {
					id
					fullName
				}
				type
				name
				person {
					id
					active
					email
					fullName
					profilePictureId
				}
				groupingOne
				groupingTwo
				groupingThree
				groupingFour
				eyeApplied
				filterApplied
				filters {
					field
					value
					operator
				}
				startDate
				endDate
				periodType
				periodDate
				reportService
				privateAccess
				state
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<UpdateSavedReportInput>,
	onSuccess?: RelayOnCompleted<updateSavedReportMutation>,
	onError?: RelayOnError,
	uploadables?: UploadableMap
): Disposable {
	const changes: string[] = [];

	for (const key of Object.keys(input)) {
		if (['id'].includes(key) || input[key] === undefined) {
			continue;
		}

		changes.push(key);
	}

	tracking.trackEvent('Saved Report Updated', {_Changed: changes});
	trackEvent('Standard Report', 'Updated');

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		uploadables,
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
